import React, { lazy } from 'react';
import { Avatar, Typography } from 'components/ui';
import styled from 'styled-components';
import { alpha, useTheme } from '@mui/material/styles';

function AutocompleteOptionUser() {

  const theme = useTheme()
  return (
    <SItem >
      <Avatar />
      <SItemInfoWrap>
        <Typography
          variant="h5"
          style={{
            // color: value.selected ? theme.palette.colors.white : theme.palette.colors.black,
          }}
        >
          {/* {firstName} {lastName} */}
        </Typography>

        {/* {birthDate && (
          <MuiBox display="flex" alignItems="baseline">
            {sex !== SEX.undefined && (
              <>
                <Icon
                  icon={getSexDate(sex).icon}
                  size="1x"
                  style={{
                    color: value.selected
                      ? alpha(theme.palette.colors.white, 0.5)
                      : theme.palette.colors.gray200,
                  }}
                />
                <Dot light={value.selected} />
              </>
            )}

            <MuiTypography
              variant="subtitle1"
              style={{
                color: value.selected
                  ? alpha(theme.palette.colors.white, 0.5)
                  : theme.palette.colors.gray200,
              }}
            >
              {countAge(birthDate)}
            </MuiTypography>
          </MuiBox>
        )} */}
      </SItemInfoWrap>
    </SItem>
  );
}

export default AutocompleteOptionUser;

const SItemInfoWrap = styled.div`
  &&{
    display: flex;
    flex-direction: column;
    padding: 0 10px;
  }

`;

const SItem = styled.div`
  && {
    display: flex;
    flex-direction: row;
    align-items: center;
    :hover {
      cursor: pointer;
    }
    margin-bottom: 5px;
  }
`;

const Dot = styled((props) => <span {...props}>&sdot;</span>)`
  margin: 5px;
  color: ${(props) => (props.light ? alpha(props.theme.palette.colors.white, 0.5) : props.theme.palette.colors.gray200)};
`;
